import { createSlice } from "@reduxjs/toolkit"

export const menuSlice = createSlice({
  name: "menu",
  initialState: {
    isMobileMenuOpen: false,
  },
  reducers: {
    setMobileMenuOpen: (state, action) => {
      state.isMobileMenuOpen = action.payload
    },
    toggleMobileMenu: (state) => {
      state.isMobileMenuOpen = !state.isMobileMenuOpen
    },
  },
})

export const { setMobileMenuOpen, toggleMobileMenu } = menuSlice.actions

export default menuSlice.reducer